import { render, staticRenderFns } from "./nim.vue?vue&type=template&id=816feae4&scoped=true&"
import script from "./nim.vue?vue&type=script&lang=js&"
export * from "./nim.vue?vue&type=script&lang=js&"
import style0 from "./nim.vue?vue&type=style&index=0&id=816feae4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816feae4",
  null
  
)

export default component.exports